<div class="container">
  <div class="benefits-header-section">
    <img class="first-left-header-Image" src="assets/merchant-landing-page/benefits-header-icon-1.png" />
    <img class="second-left-header-Image" src="assets/merchant-landing-page/rectangle-red-icon.png" />

    <div class="benefits-header-description">
      <p class="note" i18n>Benefits</p>
      <h1 i18n>Why you should partner with us </h1>
    </div>

    <img class="first-right-header-Image" src="assets/merchant-landing-page/rectangle-yellow-icon.png" />
    <img class="second-right-header-Image" src="assets/merchant-landing-page/benefits-header-icon-2.png" />
  </div>

  <div class="benefits-section-layout">
    <div class="faqs-right">
      <img src="assets/merchant-landing-page/benefit-left-icon.png" />
    </div>
    <div class="benefits-layout container">
      <div *ngFor="let item of list">
        <div class="benefit-item">
          <div class="benefit-image-div"><img src="{{ item.image }}" /></div>
          <h2>{{ item.title }}</h2>
          <p>{{ item.subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
